import axiosClient from "../axiosClient";

export function getMsisdnInfo(data) {
    let bearerTokenHeader = sessionStorage.getItem('token');
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${bearerTokenHeader}`;
    return axiosClient.post('/cc/msisdn/info', JSON.stringify(data));
}

export function unsubAction(data) {
    let bearerTokenHeader = sessionStorage.getItem('token');
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${bearerTokenHeader}`;
    return axiosClient.post('/cc/msisdn/unsub', JSON.stringify(data));
}
